import React, { useMemo } from 'react'
import Card from 'components/Card'
import dayjs from 'dayjs'
import Heading from 'components/Heading'
import NoData from 'components/NoData'
import { Spin } from 'antd'
import { useFetchPublishedReleaseNotesQuery } from 'domain/ReleaseNotes/publishedReleaseNotesApi'
import { useTranslation } from 'react-i18next'

import './viewReleaseNotes.less'

const ViewReleaseNotes = () => {
  const { t } = useTranslation()

  const { data: releaseNotesResponse, isLoading } =
    useFetchPublishedReleaseNotesQuery(undefined, {
      refetchOnMountOrArgChange: true,
    })

  const publishedList = useMemo(
    () =>
      [...(releaseNotesResponse?.data ?? [])].sort(
        (a, b) =>
          dayjs(b.releaseDate).valueOf() - dayjs(a.releaseDate).valueOf()
      ),
    [releaseNotesResponse?.data]
  )

  return (
    <div className="view-release-notes__container">
      <Heading level={1}>{t('releaseNotes.pageTitle')}</Heading>

      <Spin spinning={isLoading}>
        {!isLoading && publishedList.length === 0 ? (
          <Card>
            <NoData />
          </Card>
        ) : (
          <div className="view-release-notes__list">
            {publishedList.map(item => (
              <div className="view-release-notes__card" key={item.id}>
                <div className="view-release-notes__card-header">
                  <span className="view-release-notes__version">
                    {item.title}
                  </span>
                  <span className="view-release-notes__date">
                    {item.releaseDate
                      ? dayjs(item.releaseDate).format('MMMM D, YYYY')
                      : '-'}
                  </span>
                </div>
                <ul className="view-release-notes__notes">
                  {(item.notes ?? []).map((note, i) => (
                    <li
                      className="view-release-notes__note-item"
                      key={`${item.id}-note-${i}`}
                    >
                      •&nbsp;&nbsp;{note}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </Spin>
    </div>
  )
}

export default ViewReleaseNotes
